import DefaultMapper, { toPagingAndSorting } from '../../dataProvider/DefaultMapper';
import { API_BASE_PATH_ADMIN } from '../../constants';
import { stringify } from 'query-string';

class WalletNotificationMapper extends DefaultMapper {
	prepareCreate({ params, options, mappedResource }) {
		options.url = `${API_BASE_PATH_ADMIN}/wallet/wallets/${params.id}/notifications`;
		options.method = 'POST';
		const data = {
			description: params.data.description
		};
		options.body = JSON.stringify(data);
	}

	prepareGetList({ type, resource, params, options, mappedResource }) {
		const query = {
			...params.filter,
			...toPagingAndSorting(params)
		};
		if (params.filter.walletId) {
			options.url = `${API_BASE_PATH_ADMIN}/wallet/wallets/${params.filter.walletId}/notifications?${stringify(
				query
			)}`;
		} else {
			options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}?${stringify(query)}`;
		}
	}

	/**
	 * If the API doesn't return anything, it's the dataProvider's job to return the input data.
	 * Since we land here in case of a 2XX - we can simply override the empty response.
	 */
	finishCreate({ type, resource, params, options, mappedResource, result }) {
		return { data: { id: params.id, description: params.description } };
	}

	mapResource({ resource, params }) {
		return 'wallet/wallets/notifications';
	}
}

export default WalletNotificationMapper;
